module.exports = __webpack_public_path__ + "img/cja.a6853e48.svg";